
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
const Layout = require('@/layouts/RootFileLayout').RootFileLayout;
const meta = {
  "title": "How to build & launch a marketplace like Mercari?",
  "date": "2020-08-17"
};
const slug = 'how-to-build-launch-a-marketplace-like-mercari';
const tableOfContents = [{
  "title": "User flow",
  "slug": "user-flow",
  "children": []
}, {
  "title": "What are the list of features available in Mercari? ",
  "slug": "what-are-the-list-of-features-available-in-mercari",
  "children": []
}, {
  "title": "Social Login and Registrations",
  "slug": "social-login-and-registrations",
  "children": []
}, {
  "title": "Store Profiles",
  "slug": "store-profiles",
  "children": []
}, {
  "title": "Promotional Banners (Slideshows)",
  "slug": "promotional-banners-slideshows",
  "children": []
}, {
  "title": "Listings with multiple-attributes informations",
  "slug": "listings-with-multiple-attributes-informations",
  "children": []
}, {
  "title": "In-built chat for buyers and sellers",
  "slug": "in-built-chat-for-buyers-and-sellers",
  "children": []
}, {
  "title": "Collection Widgets",
  "slug": "collection-widgets",
  "children": []
}, {
  "title": "Listing Reviews",
  "slug": "listing-reviews",
  "children": []
}, {
  "title": "Advanced 4 Level category",
  "slug": "advanced-4-level-category",
  "children": []
}, {
  "title": "What's Next?",
  "slug": "what-s-next",
  "children": []
}, {
  "title": "Resources to build, launch and grow marketplaces",
  "slug": "resources-to-build-launch-and-grow-marketplaces",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = require('@/layouts/CustomContentsLayout').CustomContentsLayout
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p>{`Building and launching a marketplace like Mercari shouldn’t be that hard with `}<a parentName="p" {...{
        "href": "https://tradly.app"
      }}>{`TradlyPlatform`}</a>{` turn key white label solutions. How? Let’s go through this.`}</p>
    <p>{`If we want to build a similar platform like Mercari, We might need to identify how it works from userflow to revenue model, what are the list of features they have and finally the revenue model`}</p>
    <_Heading level={2} id={"user-flow"} nextElement={{
      "type": "paragraph"
    }}>User flow</_Heading>
    <p>{`Seller`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Register Account/setup store profile`}</li>
      <li parentName="ul">{`Publish Listings with information attributes and multiple photos`}</li>
      <li parentName="ul">{`Optionally share listings in multiple social networks`}</li>
      <li parentName="ul">{`Engage with the interested people through in-built chat`}</li>
      <li parentName="ul">{`Negotiate the price and get the deal`}</li>
      <li parentName="ul">{`Receive the orders`}</li>
      <li parentName="ul">{`Process the shipping through mercari shipping partners`}</li>
      <li parentName="ul">{`Receive Payments online once the Order is fullfilled`}</li>
      <li parentName="ul">{`Handle User Reviews`}</li>
    </ul>
    <p>{`Buyer`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Open the account`}</li>
      <li parentName="ul">{`Browse through listings or Search the needs`}</li>
      <li parentName="ul">{`Add few items into Wishlist and optionally browse the reviews.`}</li>
      <li parentName="ul">{`Chat with respective sellers through in-built chat`}</li>
      <li parentName="ul">{`Negotiate the price`}</li>
      <li parentName="ul">{`Make orders via online`}</li>
      <li parentName="ul">{`Receive the orders via Mercari Shipping Partners`}</li>
      <li parentName="ul">{`Once buyers are happy with the orders, They can provide reviews or skip.`}</li>
    </ul>
    <p>{`According to the user flow, we need all the features to accommodate. Let’s see what TradlyPlatform turn key white label solutions provide to launch an app like that in 2weeks with screenshots from Mercari and “feature how to: from Tradly`}</p>
    <_Heading level={2} id={"what-are-the-list-of-features-available-in-mercari"} nextElement={{
      "type": "paragraph"
    }}>What are the list of features available in Mercari? </_Heading>
    <p>{`Here we will cover all the features that are available in Mercari that you can use TradlyPlatform to build similar.`}</p>
    <_Heading level={2} id={"social-login-and-registrations"} nextElement={{
      "type": "heading",
      "depth": 2
    }}>Social Login and Registrations</_Heading>
    <_Heading level={2} id={"store-profiles"} nextElement={{
      "type": "paragraph"
    }}>Store Profiles</_Heading>
    <p><img parentName="p" {...{
        "src": "images/Store-Profile-Android-512x1024.png",
        "alt": null
      }}></img></p>
    <p>{`How one of StoreProfile creation looks from TradlyPlatform powered app`}</p>
    <_Heading level={2} id={"promotional-banners-slideshows"} nextElement={{
      "type": "paragraph"
    }}>Promotional Banners (Slideshows)</_Heading>
    <p><img parentName="p" {...{
        "src": "https://i2.wp.com/tradly.app/wp-content/uploads/2020/08/Promo-Banners.png?fit=750%2C313&ssl=1",
        "alt": null
      }}></img></p>
    <p>{`What you see on Mercari`}</p>
    <_Heading level={2} id={"listings-with-multiple-attributes-informations"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Listings with multiple-attributes informations</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul"><img parentName="li" {...{
          "src": "img/Listing-Attributes-909x1024.png",
          "alt": null
        }}></img>
        {`  One of a listing shown from Mercari
`}</li>
      <li parentName="ul"><img parentName="li" {...{
          "src": "img/Submit-Listing-iOS-576x1024.png",
          "alt": null
        }}></img>
        {`  What you see on TradlyPlatform powered app. You can configure multiple attributes through your `}<a parentName="li" {...{
          "href": "https://superadmin.tradly.app"
        }}>{`SuperAdmin Panel`}</a>
      </li>
    </ul>
    <_Heading level={2} id={"in-built-chat-for-buyers-and-sellers"} nextElement={{
      "type": "heading",
      "depth": 2
    }}>In-built chat for buyers and sellers</_Heading>
    <_Heading level={2} id={"collection-widgets"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Collection Widgets</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul"><img parentName="li" {...{
          "src": "https://i2.wp.com/tradly.app/wp-content/uploads/2020/08/Collection-Widget.png?fit=750%2C312&ssl=1",
          "alt": null
        }}></img>
      </li>
      <li parentName="ul"><img parentName="li" {...{
          "src": "https://i0.wp.com/tradly.app/wp-content/uploads/2020/08/Collection-Widget3.png?fit=750%2C248&ssl=1",
          "alt": null
        }}></img>
      </li>
      <li parentName="ul"><img parentName="li" {...{
          "src": "https://i1.wp.com/tradly.app/wp-content/uploads/2020/08/See-whats-selling-Collection-Widget.png?fit=750%2C250&ssl=1",
          "alt": null
        }}></img>
      </li>
    </ul>
    <_Heading level={2} id={"listing-reviews"} nextElement={{
      "type": "paragraph"
    }}>Listing Reviews</_Heading>
    <p><img parentName="p" {...{
        "src": "https://i0.wp.com/tradly.app/wp-content/uploads/2020/08/Reviews.png?fit=750%2C265&ssl=1",
        "alt": null
      }}></img></p>
    <p>{`Reviews available in Mercari`}</p>
    <_Heading level={2} id={"advanced-4-level-category"} nextElement={{
      "type": "paragraph"
    }}>Advanced 4 Level category</_Heading>
    <p><img parentName="p" {...{
        "src": "https://i1.wp.com/tradly.app/wp-content/uploads/2020/08/4-Level-Categories.png?fit=750%2C480&ssl=1",
        "alt": null
      }}></img></p>
    <p>{`Mercari has 3 level of category on the top menu`}</p>
    <_Heading level={2} id={"what-s-next"} nextElement={{
      "type": "paragraph"
    }}>What's Next?</_Heading>
    <p>{`Not just this, there are other dozens of features which TradlyPlatform app has. But building a similar platform like Mercari now should be very easy and the apps can be launched in 2Weeks. `}<a parentName="p" {...{
        "href": "https://tradly.app"
      }}>{`Contact us for more info and demo`}</a></p>
    <p><em parentName="p"><a parentName="em" {...{
          "href": "https://tradly.app/signup"
        }}>{`Signup to Start Building For Free ACCOUNT`}</a></em></p>
    <hr></hr>
    <_Heading level={2} id={"resources-to-build-launch-and-grow-marketplaces"} nextElement={{
      "type": "export"
    }}>Resources to build, launch and grow marketplaces</_Heading>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
